<div style="margin-bottom: 5px; margin-top: 20px;">

  <ion-card class="card"
    [ngStyle]="{'background-image': 'linear-gradient(#333a 7%, transparent 25%), url(' + getImage() + ')', height:imageHeight}">

    <ion-row (click)="viewFeedDetails()" *ngIf="!details">

      <ion-col size="10.5">
        <div class="font1_5 scrollable" style="height: 8vw;">{{feed.header}}</div>
        <!-- <div *ngIf="details" class="scrollable" style="height: 16vw;">{{feed.description}}</div> -->
      </ion-col>
      <ion-col size="0.5">

      </ion-col>
      <ion-col size="1" style="height: 24vw;" class="scrollable">
        <div *ngIf="feed.reactionKeys">
          <div class="singleLine" *ngFor="let key of feed.reactionKeys">{{feed.reaction_count[key]}} {{key}}</div>
        </div>
      </ion-col>
    </ion-row>



    <ion-row *ngIf="showEmojiBox" class="emojiBox">
      <ion-col size="2" *ngFor="let emoji of reactionService.emojiList" (click)="clickEmoji(emoji)" class="font1_5">
        {{emoji}}
      </ion-col>
    </ion-row>
  </ion-card>
  <ion-card style=" margin: -15px 5px 5px 5px;">
    <ion-row>
      <ion-col size="12">
        <a *ngIf="feed.json_details.contact_number || feed.json_details.contact"
          [href]="'tel:'+feed.json_details.contact_number">
          <ion-row>
            <ion-col size="1">
              <ion-icon color="tertiary" name="call-outline"></ion-icon>
            </ion-col>
            <ion-col size="11">
              <div style="width: 100%; overflow-x: auto; white-space: nowrap;">
                <b>{{feed.json_details.contact}}</b>,{{feed.json_details.contact_number}}
              </div>
            </ion-col>
          </ion-row>
        </a>
      </ion-col>
      <ion-col size="1.5">
        <span *ngIf="feed.creator">
          <img width="30px" height="30px" [src]="feed.creator.url" *ngIf="feed.creator && feed.creator.url"
            class="circular">
          <ion-icon name="person-circle-outline" *ngIf="!feed.creator.url" class="font3" color="light"></ion-icon>
        </span>
      </ion-col>
      <ion-col [size]="details ? '9.5' : '7.5'">
        <div *ngIf="feed.creator">{{feed.creator.name}}</div>
        <div class="font0_8">{{feed.created_at | fancyDate}}</div>

      </ion-col>
      <ion-col class="font1_5" size="1">
        <ion-icon name="logo-whatsapp" (click)="feedService.share(feed)"></ion-icon>
      </ion-col>
      <ion-col class="font1_5" size="1" *ngIf="!details">
        <ion-icon (click)="showEmojiBox = !showEmojiBox" name="heart-outline"></ion-icon>
      </ion-col>
      <ion-col class="font1_5" size="1" *ngIf="!details">
        <ion-icon (click)="viewFeedDetails()" name="chatbubble-outline"></ion-icon>
      </ion-col>
    </ion-row>
  </ion-card>
  <ion-card *ngIf="details" style="margin: -5px 5px 5px 5px; padding: 5px;">
    <div class="font1_2 bold">{{feed.header}}</div>
    <!-- <div>{{feed.description | linebreaks}}</div> -->
    <div [innerHTML]="feed.description"></div>
  </ion-card>
</div>